import { trackEvent, generateEventId } from './metaPixel'

export const HOTMART_CHECKOUT_URL = 'https://pay.hotmart.com/J106065263T'

/**
 * Fires the Meta Pixel InitiateCheckout event and redirects to Hotmart.
 *
 * For deduplication to work, the SAME event_id must reach both:
 *   1. the browser pixel (fbq track), and
 *   2. the server-side Conversions API event.
 *
 * We generate one shared event_id here, send it to the browser pixel, and
 * forward it to Hotmart on the URL (as `event_id` + mirrored in `sck`/`xcod`
 * tracking params) so Hotmart's Conversions API integration can relay the
 * matching key back to Meta. This satisfies Meta's "matching deduplication
 * keys" recommendation for InitiateCheckout.
 *
 * Use this as the onClick handler for every "Buy" CTA button.
 */
export function goToCheckout(): void {
  const eventId = generateEventId()

  // 1. Browser pixel event — tagged with the shared event_id.
  trackEvent(
    'InitiateCheckout',
    {
      content_name: 'Alpha Protocol',
      content_category: 'Digital Product',
      value: 6.36,
      currency: 'USD',
    },
    eventId,
  )

  // 2. Forward the same event_id to Hotmart so the server-side (CAPI) event
  //    can be deduplicated against the browser event using a matching key.
  const url = new URL(HOTMART_CHECKOUT_URL)
  url.searchParams.set('event_id', eventId)
  // Mirror into Hotmart tracking params so it survives the checkout flow.
  url.searchParams.set('sck', eventId)
  url.searchParams.set('xcod', eventId)

  window.location.href = url.toString()
}
